import { Images } from '@/assets/imgs';
import { TeamMember, Metadata, User } from './types';

export const CardData = [
  {
    icon: 'icon1',
    title: 'Community',
    description:
      'Our ecosystem and products are shaped and owned by our community members.',
  },
  {
    icon: 'icon2',
    title: 'Empowerment',
    description:
      'We believe players deserve to own, govern and earn for their contribution to the gaming industry.',
  },
  {
    icon: 'icon3',
    title: 'Innovation',
    description:
      'We are committed to developing transparent technologies that even the playing field for players.',
  },
];

export const TeamData: TeamMember[] = [
  {
    name: 'Arturas Miceika',
    intro: 'Frontend Engineer',
    photoUrl: '/images/about/team/arturas_miceika.png',
    department: 'tech',
  },
  {
    name: 'Connor Kristen',
    intro: 'Head Of Growth',
    photoUrl: '/images/about/team/connor_kristen.png',
    department: 'growth',
  },
  {
    name: 'Donatas Paskacius',
    intro: 'Software Engineer',
    photoUrl: '/images/about/team/donatas_paskacius.png',
    department: 'tech',
  },
  {
    name: 'Gauthier Collas',
    intro: 'COO',
    photoUrl: '/images/about/team/gauthier_collas.png',
    department: 'ops',
  },
  {
    name: 'Huy',
    intro: '3D Designer',
    photoUrl: '/images/about/team/huy.png',
    department: 'design',
  },
  {
    name: 'James Ward',
    intro: 'Senior Software Engineer',
    photoUrl: '/images/about/team/james_ward.png',
    department: 'tech',
  },
  {
    name: 'Joao Goncalves',
    intro: 'Head Of Business Development',
    photoUrl: '/images/about/team/joao_goncalves.png',
    department: 'growth',
  },
  {
    name: 'Julien Morel',
    intro: 'Prompt Engineer',
    photoUrl: '/images/about/team/julien_morel.png',
    department: 'design',
  },
  {
    name: 'Laureline David',
    intro: 'Senior Software Engineer',
    photoUrl: '/images/about/team/laureline_david.png',
    department: 'tech',
  },
  {
    name: 'Louis Regis',
    intro: 'Founder & CEO',
    photoUrl: '/images/about/team/louis_regis.png',
    department: 'product',
  },
  {
    name: 'Mamali Ghorbani',
    intro: 'Senior Frontend Engineer',
    photoUrl: '/images/about/team/mamali_ghorbani.png',
    department: 'tech',
  },
  {
    name: 'Moussa Berte',
    intro: 'Senior Software Engineer',
    photoUrl: '/images/about/team/moussa_berte.png',
    department: 'tech',
  },
  {
    name: 'oz',
    intro: 'Head Of Community',
    photoUrl: '/images/about/team/oz.png',
    department: 'growth',
  },
  {
    name: 'paulius_pipiras',
    intro: 'Head Of Design',
    photoUrl: '/images/about/team/paulius_pipiras.png',
    department: 'design',
  },
  {
    name: 'Pedro',
    intro: '3D Designer',
    photoUrl: '/images/about/team/pedro.png',
    department: 'design',
  },
  {
    name: 'Sam Sheikh',
    intro: 'Product Manager',
    photoUrl: '/images/about/team/sam_sheikh.png',
    department: 'product',
  },
  {
    name: 'Sean Hiroshi',
    intro: 'Animation Lead',
    photoUrl: '/images/about/team/sean_hiroshi.png',
    department: 'design',
  },
  {
    name: 'Stijn Van Impe',
    intro: 'Lead 3D Designer',
    photoUrl: '/images/about/team/stijn_vanimpe.png',
    department: 'design',
  },
  {
    name: 'Weslei',
    intro: 'Software Engineer',
    photoUrl: '/images/about/team/weslei.png',
    department: 'tech',
  },
];

export const FooterLinksData = [
  {
    type: 'ECOSYSTEM',
    links: [
      {
        name: 'Infrastructure',
        to: '/infrastructure',
      },

      {
        name: 'XBG',
        to: '/xbg',
      },
    ],
  },
  {
    type: 'Products',
    links: [
      {
        name: 'GamerBase',
        to: 'https://gamerbase.gg/',
      },
      {
        name: 'Launchpad',
        to: 'https://launchpad.xborg.com/',
      },
    ],
  },
  {
    type: 'Community',
    links: [
      {
        name: 'Prometheus',
        to: '/prometheus-nft',
      },
      {
        name: 'Snapshot',
        to: 'https://snapshot.org/#/xborg.eth',
      },
    ],
  },
  {
    type: 'Company',
    links: [
      {
        name: 'About',
        to: '/about-us',
      },
      {
        name: 'Blog',
        to: 'https://medium.com/xborg-official',
      },

      {
        name: 'Careers',
        to: 'https://jobs.lever.co/swissborg?department=XBorg',
      },
    ],
  },
];

export const PossibilitiesData = [
  {
    title: 'Payments & fees',
    description:
      'XBG is used for all payments and transaction fees within the XBorg ecosystem.',
    icon: Images.xbg.discovery5,
  },
  {
    title: 'Governance',
    description:
      'Vote on key product, business and ecosystem decisions with XBG.',
    icon: Images.xbg.discovery6,
  },
  {
    title: 'Incentives & revenue share',
    description:
      '50% of XBorg revenue is sent to the reward pool providing staking yield to XBG stackers, weighted by ecosystem contribution.',
    icon: Images.xbg.discovery7,
  },
  {
    title: 'Gated Access',
    description:
      'Enjoy premium ecosystem benefits based on your XBG holdings like higher allocations for our Launchpad and ITO sales.',
    icon: Images.xbg.discovery8,
  },
  {
    title: 'Gas token',
    description:
      'The XBG token will be used as the gas token for the XBorg app chain.',
    icon: Images.xbg.discovery9,
  },
];

export const GamingUserData: User[] = [
  {
    img: Images.infrastructure.gamingWebLogo1,
    name: 'MonkeyIslander872',
    player_metadata: {
      player_name: 'JohnDoe1',
      gaming_platform: 'PC',
      game_level: 25,
      achievements: ['Master of the Arena', 'Legendary Explorer'],
      total_score: 2000,
      preferred_game_mode: 'Team Deathmatch',
      'collected items': {
        weapon: 'Legendary Sword',
        armor: 'Epic Plate Armor',
        pet: 'Fire Dragon',
      },
    },
  },
  {
    img: Images.infrastructure.gamingWebLogo2,
    name: 'mean_deal_',
    player_metadata: {
      player_name: 'JohnDoe12',
      gaming_platform: 'PC',
      game_level: 25,
      achievements: ['Master of the Arena', 'Legendary Explorer'],
      total_score: 2000,
      preferred_game_mode: 'Team Deathmatch',
      'collected items': {
        weapon: 'Legendary Sword',
        armor: 'Epic Plate Armor',
        pet: 'Fire Dragon',
      },
    },
  },
  {
    img: Images.infrastructure.gamingWebLogo3,
    name: 'TennisChallenger',
    player_metadata: {
      player_name: 'JohnDoe123',
      gaming_platform: 'PC',
      game_level: 25,
      achievements: ['Master of the Arena', 'Legendary Explorer'],
      total_score: 2000,
      preferred_game_mode: 'Team Deathmatch',
      'collected items': {
        weapon: 'Legendary Sword',
        armor: 'Epic Plate Armor',
        pet: 'Fire Dragon',
      },
    },
  },
  {
    img: Images.infrastructure.gamingWebLogo4,
    name: 'DoozieWoozie',
    player_metadata: {
      player_name: 'JohnDoe12',
      gaming_platform: 'PC',
      game_level: 25,
      achievements: ['Master of the Arena', 'Legendary Explorer'],
      total_score: 2000,
      preferred_game_mode: 'Team Deathmatch',
      'collected items': {
        weapon: 'Legendary Sword',
        armor: 'Epic Plate Armor',
        pet: 'Fire Dragon',
      },
    },
  },
  {
    img: Images.infrastructure.gamingWebLogo5,
    name: 'tiredOfbeIngWired',
    player_metadata: {
      player_name: 'JohnDoe12',
      gaming_platform: 'PC',
      game_level: 25,
      achievements: ['Master of the Arena', 'Legendary Explorer'],
      total_score: 2000,
      preferred_game_mode: 'Team Deathmatch',
      'collected items': {
        weapon: 'Legendary Sword',
        armor: 'Epic Plate Armor',
        pet: 'Fire Dragon',
      },
    },
  },
  {
    img: Images.infrastructure.gamingWebLogo6,
    name: 'Greendragon_',
    player_metadata: {
      player_name: 'JohnDoe123',
      gaming_platform: 'PC',
      game_level: 25,
      achievements: ['Master of the Arena', 'Legendary Explorer'],
      total_score: 2000,
      preferred_game_mode: 'Team Deathmatch',
      'collected items': {
        weapon: 'Legendary Sword',
        armor: 'Epic Plate Armor',
        pet: 'Fire Dragon',
      },
    },
  },
];
